
import MessageRemove from "../../../assets/filled/MessageRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageRemoveIcon({ className, dataTestid = "MessageRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
